import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class MainSearchAPI {
  
  static list = (search, body, success, failure) => {
    fetch(Config.app.link + 'api/main-search/' + encodeURIComponent(search.trim()), new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static search = (body, success, failure) => {
    fetch(Config.app.link + 'api/main-search-non-restrict', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static propertySearch = (searchQuery,success, failure) => {
    fetch(Config.app.link + 'api/property-search/'+ encodeURIComponent(searchQuery.trim()), new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default MainSearchAPI;